import React from "react";
import "../css/ReferralPage.css";
// import shareEarnImg from "../assets/share_earn.png";
import Header from "../Common/Header";
import Footer from "../Common/Footer";

const ReferralPage = () => {
  return (
    <div className="referral-wrapper">
        <Header/>

      {/* Section 1: Top Content */}
      <section className="referral-top">
        <div className="referral-left">
          <h2>💡 Grow Together with Our Referral Program</h2>
          <p>Turn your network into a revenue opportunity! With our easy-to-use referral <br></br>program, you can invite friends, colleagues, or clients to try our platform — and <br></br>get rewarded every time they sign up or make a purchase.</p>
          
          <ul>Here's how it works</ul>
          <ul>
            
            <li>Share your unique referral link with your network.</li>
            <li>Your referrals sign up and explore the power of our CRM & ERP tools.</li>
            <li>You earn rewards — like discounts, credits, or even cash — for each<br></br> successful referral.</li>
          </ul>
          <p className="highlight">⭐ Start referring today and grow with us.</p>
          <button className="purple-btn">Earn Now $</button>
        </div>
        <div className="referral-right">
         <img src="./images/referralpic.png" alt="Share and Earn" /> 
        </div>
      </section>

     <section className="referral-highlights">
  <h3>✨ Referral Program Highlights</h3>
  <div className="highlight-grid">
    {[
      {
        title: "Get a unique referral link",
        desc: "Share with friends, or clients. Easily generate your personalized referral link to start inviting others instantly.",
        icon: "📎"
      },
      {
        title: "Track your referrals and earnings",
        desc: "Stay updated with a live dashboard showing who joined and what you’ve earned.",
        icon: "📊"
      },
      {
        title: "Invite unlimited people",
        desc: "There’s no limit to how many people you can refer — the more you share, the more you earn.",
        icon: "👥"
      },
      {
        title: "Quick & easy process",
        desc: "No complicated setup — just sign in, copy your link, and start sharing.",
        icon: "⏱️"
      },
      {
        title: "Earn rewards for every successful signup",
        desc: "Receive bonuses whenever someone you referred signs up or makes a qualifying purchase.",
        icon: "💰"
      },
      {
        title: "Help others grow by introducing them to Sess",
        desc: "Let your network discover advanced tools for lead generation, automation, and team management.",
        icon: "🚀"
      },
      {
        title: "Choose your reward type",
        desc: "Pick the reward that suits you best — whether it’s platform credits, discounts, or real cash.",
        icon: "🎁"
      },
      {
        title: "Trusted system ensures transparent and secure",
        desc: "We use a secure and transparent system to track your referrals and ensure timely rewards.",
        icon: "🔒"
      }
    ].map((item, index) => (
      <div key={index} className="highlight-card">
        <div className="text-block">
          <h4>{item.title}</h4>
          <p>{item.desc}</p>
        </div>
        <span className="icon-block">{item.icon}</span>
      </div>
    ))}
  </div>
</section>

      {/* Section 3: Steps */}
      <section className="referral-steps">
        <h3>Steps To Monetize Your Account</h3>
        <div className="steps-grid">
          {[
            ["1", "Create your free account and access your unique referral link."],
            ["2", "Share your link with friends, clients, or your network."],
            ["3", "Once someone signs up using your link and completes a paid transaction..."],
            ["4", "Earn a commission directly into your wallet — simple, transparent, and rewarding."]
          ].map(([num, text]) => (
            <div key={num} className="step-box">
              <div className="step-num">{num}</div>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Section 4: Footer */}
   <Footer/>
    </div>
  );
};

export default ReferralPage;
